import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  mainText: {
    marginBottom: theme.spacing(4),
  },
}));

export { useStyles };
